import type { ScopeTree } from '@/lib/api-types';

export interface AdminScope {
	cerId: string;
	configId: string | null;
}

/**
 * Lo scope admin da impostare quando si apre una CER o una configurazione
 * (INB-331): la CER su cui si lavora resta selezionata in tutte le tab.
 *
 * - `orgId` è una CER dell'albero → quella CER; la configurazione corrente
 *   resta se è sua, altrimenti la prima.
 * - `orgId` è una configurazione → la sua CER e quella configurazione.
 * - altrimenti (CER disabilitata, non amministrabile, albero non caricato) →
 *   `null`: lo scope non si tocca, `useScopeSync` lo rimetterebbe a posto.
 */
export function adminScopeFor(
	tree: ScopeTree,
	orgId: string,
	currentConfigId: string | null,
): AdminScope | null {
	const cer = tree.find((c) => c.id === orgId);
	if (cer) {
		const keep = cer.configs.some((cfg) => cfg.id === currentConfigId);
		return { cerId: cer.id, configId: keep ? currentConfigId : (cer.configs[0]?.id ?? null) };
	}
	const parent = tree.find((c) => c.configs.some((cfg) => cfg.id === orgId));
	return parent ? { cerId: parent.id, configId: orgId } : null;
}
